import { SpaceBetween, tk } from '@sunwebgroup/ui-components'
import React from 'react'
import { styled } from 'styled-components'
import { InWebsiteLanguageFilter } from './InWebsiteLanguageFilter'
import { PartyCompositionFilter } from './PartyCompositionFilter'
import { SortingSelect } from './SortingSelect'

const Wrapper = styled(SpaceBetween)`
  margin-bottom: ${tk('spacing_md')};
`
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  flex-direction: column;

  @media ${tk('mq_desktop_md')} {
    flex-direction: row;
    align-items: center;
  }
`

export function Filters() {
  return (
    <Wrapper direction="y">
      <PartyCompositionFilter />
      <Content>
        <InWebsiteLanguageFilter />
        <SortingSelect />
      </Content>
    </Wrapper>
  )
}
